(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/react/shared-components/navigation.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/react/shared-components/navigation.js');

'use strict';

const {
  ItemsMenu,
  BallItem
} = svs.ui.ReactItemsMenu;
const {
  NavLink
} = svs.app.ReactRouter;
const Icon = svs.ui.ReactIcon;
const Brand = svs.ui.ReactBrand;
const FirstNavItem = () => React.createElement(NavLink, {
  exact: true,
  tabIndex: "-1",
  title: "Alla",
  to: "/"
}, React.createElement(BallItem, {
  className: "fg-icon-ball-item",
  label: "Alla",
  to: "/"
}, React.createElement(Icon, {
  color: "fc-white",
  icon: "andelsspel"
})));
const ProductNavItem = _ref => {
  let {
    productName,
    to,
    backgroundClass
  } = _ref;
  return React.createElement(NavLink, {
    tabIndex: "-1",
    title: productName,
    to: to
  }, React.createElement(BallItem, {
    label: productName
  }, React.createElement(Brand, {
    brand: productName,
    className: backgroundClass
  })));
};
const ProductNavItems = _ref2 => {
  let {
    items
  } = _ref2;
  return items.map(_ref3 => {
    let {
      productName,
      to,
      backgroundClass
    } = _ref3;
    return React.createElement(ProductNavItem, {
      backgroundClass: backgroundClass,
      key: productName,
      productName: productName,
      to: to
    });
  });
};
const Navigation = _ref4 => {
  let {
    navItems
  } = _ref4;
  return React.createElement(ItemsMenu, {
    branding: "fractiongames",
    centered: true,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, React.createElement(FirstNavItem, null), React.createElement(ProductNavItems, {
    items: navItems
  }));
};
svs.fractiongames.components.Navigation = Navigation;

 })(window);